import { AxiosRequestConfig } from 'axios'
import { useApi } from '../hooks'
import { AssetGroup } from '../types'

const api = useApi('/v2')

export async function getAssetGroups(config?: AxiosRequestConfig) {
  const response = await api.get<AssetGroup[]>('/asset-groups', config)

  return response.data
}

export async function getAssetGroup(id: string, config?: AxiosRequestConfig) {
  const response = await api.get<AssetGroup>(`/asset-groups/${id}`, config)

  return response.data
}
